var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 47.0001C41.6274 47.0001 47 41.6275 47 35.0001C47 28.3727 41.6274 23.0001 35 23.0001C28.3726 23.0001 23 28.3727 23 35.0001C23 41.6275 28.3726 47.0001 35 47.0001Z",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8596 31.1401L31.1396 38.8501",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8596 38.8501L31.1396 31.1401",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 27.5L25 17.5L10 23.5L1 14.5L8 11.5L14 14.5L41.3 2.59999C43.4 1.69999 45.7 2.69999 46.6 4.79999C47.4 6.79999 46.4 9.19999 44.4 9.99999L35 13.5L32.5 18",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2996 6.5L18.9996 1L11.5996 4.1L25.0996 9.6",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.15527e-05H48V48.0001H0V9.15527e-05Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrip);
export default __webpack_public_path__ + "static/media/trip.2e264ba3ab58dd84b6adc2e9d78e25ae.svg";
export { ForwardRef as ReactComponent };